<template>
  <div class="box">
    <p v-for="(item, index) in computeNumber" :key="index" class="box-item">
      <span :style="{ transform: 'translate(-50%,-' + item * 10 + '%)' }"
        >0123456789</span
      >
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      count: 300
    }
  },
  mounted() {
    setInterval(() => {
      this.count = this.count + 5
    }, 400000)
  },
  computed: {
    computeNumber() {
      let str = this.count + ''
      let strLen = str.length
      if (strLen < 5) {
        let bu = 8 - strLen
        for (let i = 0; i < bu; i++) {
          str = '0' + str
        }
      }
      return str.split('')
    }
  }
  // props: {
  //   count: {
  //     type: Number,
  //     default: 1000
  //   }
  // }
}
</script>

<style scoped lang="less">
.box {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
}
.box-item {
  position: relative;
  display: inline-block;
  width: 54px;
  height: 82px;
  margin: 0px 2px;
  padding: 0px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  background-color: rgba(62, 111, 167, 0.44);
  font-size: 62px;
  line-height: 82px;
  text-align: center;
  color: #ffffff;
  border-radius: 5px;
  position: relative;
  writing-mode: vertical-lr;
  text-orientation: upright;
  overflow: hidden;
  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 1px;
    background-color: rgba(255, 255, 255, 0.5);
  }
  span {
    position: absolute;
    left: 50%;
    top: 13px;
    font-size: 56px;
    font-family: PangMenZhengDao;
    font-weight: bold;
    letter-spacing: 10px;
    transition: transform 1s ease-in-out;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/dashboard/china/numberScroll.vue